<template>
<!--此部分根据设计自动生成，手动修改节点标记daltag="manual"属性，则该节点及子节点不会被自动生成代码覆盖，如发现其他需要调整框架情形请联系:alex.c@daline.com.cn-->
<div id="dal-comp-talk">
  <el-table id="aa344af0" :data="tbd_aa344af0" stripe="" border="">
    <el-table-column prop="a800adf7" label="客户名称">
    </el-table-column>
    <el-table-column prop="dda509b3" label="电话号码">
    </el-table-column>
    <el-table-column prop="a4614af4" label="电子邮箱">
    </el-table-column>
    <el-table-column prop="beec8c80" label="登记时间">
    </el-table-column>
    <el-table-column prop="a957501e" label="销售专员">
    </el-table-column>
    <el-table-column prop="af2c5d77" label="产品经理">
    </el-table-column>
    <el-table-column prop="aaed7d50" label="项目经理">
    </el-table-column>
    <el-table-column prop="f3895391" label="备注">
    </el-table-column>
  </el-table>
</div>
</template>
<script>
//此文件根据设计自动生成编写框架，请在指定位置编写逻辑代码，如发现框架需要调整的情形请联系:alex.c@daline.com.cn
//在此注释下方添加自定义import
//在此注释下方添加自定义函数
//此注释下方为自动引用部分，请不要修改
export default{
  data(){
    return{
    tbd_aa344af0:[]
      //在此注释下方添加自定义变量
    }
  },
  mounted(){
  },
  computed:{
  },
  watch:{
  },
  methods:{
    //在此注释下方添加自定义函数或事件
  }
}
</script>
<style>
/*此部分根据设计自动生成，自定义样式追加到该部分结尾处*/
#aa344af0{
  width:1322px;
}
#aa344af0{
  display:inline-block;
  vertical-align: middle;
}
/*在此注释下方添加自定义样式*/
</style>
